document.addEventListener('DOMContentLoaded', function () {
  var footers = document.querySelectorAll('.cb-footer');

  footers.forEach(function (footer) {
    var accordionCols = footer.querySelectorAll('.cb-footer__col--details, .cb-footer__col--menu');

    accordionCols.forEach(function (col) {
      var toggle = col.querySelector('[data-footer-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var isOpen = col.classList.contains('is-open');

        accordionCols.forEach(function (otherCol) {
          otherCol.classList.remove('is-open');
          var otherToggle = otherCol.querySelector('[data-footer-toggle]');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          col.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
});